import type { CSSProperties } from "react";
import { colorForOwner } from "../../shared/colors";

// Sticker-style name tag for a sweepstake player. Carries the owner's
// accent colour as a CSS variable so themes can restyle or recolour it.
export default function OwnerTag({
  owner,
  size = "sm",
}: {
  owner: string;
  size?: "sm" | "lg";
}) {
  return (
    <span
      className={"owner-pill" + (size === "lg" ? " owner-pill--lg" : "")}
      data-owner={owner}
      style={{ "--owner-c": colorForOwner(owner) } as CSSProperties}
    >
      {owner}
    </span>
  );
}
